import React from 'react';
import PropTypes from 'prop-types';
import StylePropType from 'react-style-proptype';

function CenteredWrapper(props) {
  const alignment = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end',
  };

  return (
    <div
      style={{
        margin: '100px auto',
        width: props.width,
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: alignment[props.align],
        ...props.style,
      }}
    >
      {props.children}
    </div>
  );
}

CenteredWrapper.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right']),
  width: PropTypes.number,
  style: StylePropType,
};

CenteredWrapper.defaultProps = {
  align: 'left',
  width: 400,
  style: {},
};

export default CenteredWrapper;



// WEBPACK FOOTER //
// ./src/components/CenteredWrapper.js